<template>
  <div class="templates">
    <p class="form__checkbox">
      <input type="checkbox" v-model="templatesByClass" id="by-class">
      <label for="by-class">Фильтр по классу</label>
    </p>
    <HomeworkItem 
      v-for="template in templateList"
      :key="template.id"
      :item="template" 
      :is_template="true"
      :class_students="classItem.students"
    />

    <p class="missing-message" v-show="!templateList.length">Шаблонов нет</p>
  </div>    
</template>

<script>
import HomeworkItem from './HomeworkItem.vue'
import { mapState } from 'vuex'
export default {
  props: ['classItem'],
  components: { HomeworkItem },
  data() {
    return {
      templatesByClass: true
    }
  },
  computed: {
    ...mapState({
      templates: state => state.teacher.teacherTemplates
    }),
    templateList() {
      if (this.templatesByClass) {
        return this.templates.filter(item => item.class_id === this.classItem.id)
      } else {
        return this.templates
      }
    }  
  }
}
</script>

<style lang="scss" scoped>
.templates {
  width: 100%;
  margin-top: 20px;
}
</style>